import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-lesson-card',
    imports: [CommonModule, MatTooltipModule],
    templateUrl: './lesson-card.component.html',
    styleUrl: './lesson-card.component.scss'
})
export class LessonCardComponent implements OnChanges {
  @Input() imageData: string = ''; 
  @Input() title: string = '';
  @Input() progress: number = 0;
  @Input() disabled: boolean = false;
  @Input() tooltip: string = '';

  ngOnChanges() {
    if (!this.imageData) {
      this.imageData = './assets/images/Baerchen_winkt.png'; //Placeholder image
    }
  }
}

